module.exports = __webpack_public_path__ + "static/media/mongodb.28ec40a4.png";